export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const ADMIN_SERVICE_USER = process.env.REACT_APP_ADMIN_SERVICE_USER || '';

// TODO: This will be removed once the authentication is implemented
export const API_AUTHORIZATION_TOKEN = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InRlc3RAZXhhbXBsZS5jb20iLCJpc0FkbWluIjp0cnVlLCJ1c2VySWQiOiJkNGMxNGFhMS04Y2M2LTQ4YzMtOGM0My04ZDI5ZjIyNzYxZTkiLCJleHBpcnkiOiIyMDI1LTAxLTAzIDA0OjUzOjQxLjk1NjA0MiswMDowMCJ9.thdy8-qB_ZWEVhxGk-DlUcjXuz9VeuJNX3C_gwVzkJk';
export const API_HEADERS = {
  'Content-Type': 'application/json',
  'Authorization': API_AUTHORIZATION_TOKEN
};

export const SKILLS_URL = `${API_BASE_URL}/skills`;
export const AGENTS_URL = `${API_BASE_URL}/agents`;
export const PACKAGES_URL = `${API_BASE_URL}/packages`;
export const PROMPTS_URL = `${API_BASE_URL}/prompts`;
export const ANNOTATION_URL = `${API_BASE_URL}/annotation`;
export const ADMIN_URL = `${API_BASE_URL}/admin`;
export const USERS_URL = `${API_BASE_URL}/users`;
export const SYSTEM_INFO_URL = `${API_BASE_URL}/system-info`;
export const PRODUCTS_URL = `${API_BASE_URL}/products`;
export const TAGS_URL = `${API_BASE_URL}/tags`;
export const ADAPTERS_URL = `${API_BASE_URL}/adapters`;
export const ADAPTER_URL = `${API_BASE_URL}/adapter`;

export const DEFAULT_SKILL_TIMEOUT = '30'; // seconds ; TODO: Move this to a different file